import {
  memo, useState,
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import OverviewDetails from './OverviewDetails';
import ItineraryDetails from './ItineraryDetails';
import ImageGallery from '../../../ImageGallery';
import PricingDetails from './PricingDetails';
import TabPanel from '../../../TabPanel';

const TourDetails = ({ itinerary, tripId }) => {
  const selectedTabClasses = 'text-theme border-b-2 border-theme';
  const tabs = [
    {
      title: 'Overview',
      content: <OverviewDetails content={itinerary.detailTabs[0].content} />,
    },
    {
      title: 'Itinerary',
      content: <ItineraryDetails content={itinerary.detailTabs[1].content} />,
    },
    {
      title: 'Photos',
      content: <ImageGallery images={itinerary.photos} />,
    },
    {
      title: 'Pricing',
      content: <PricingDetails
        itinerary={itinerary}
        tripId={tripId}
      />,
    },
  ];
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  return (
    <div>
      <div className="grid grid-flow-col auto-cols-max gap-5 border-b-2 mb-5 overflow-x-auto">
        {tabs.map((tab, index) => (
          <a
            key={tab.title}
            onClick={() => { handleTabChange(index); }}
            onKeyDown={() => { handleTabChange(index); }}
            role="button"
            tabIndex={tabs.length - index}
            className={clsx(selectedTab === index && selectedTabClasses, 'py-4 text-sm mt-auto md:text-base lg:w-24 text-center focus:outline-none block w-full')}
          >
            {tab.title}
          </a>
        ))}
      </div>
      {
        tabs.map((tab, index) => (
          <TabPanel value={selectedTab} index={index} key={tab.title}>
            {tab.content}
          </TabPanel>
        ))
            }
    </div>
  );
};
TourDetails.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
};
TourDetails.defaultProps = {
  tripId: '',
};

export default memo(TourDetails);
